let PLP
function vuePLP() {
    PLP = Vue.createApp({
        delimiters: ['#{', '}'],
        setup() {

            const collectionConfig = Vue.reactive({
                pageLength: 48,
                sortKey: "RELEVANCE",
                descending: false,
                handle: window.location.pathname.replaceAll('/collections/', ''),
                vehicleFilters: [],
                pageFilters: [],
                cursor: '',
                locationCursor: '',
                hasNextPage: true,
                unavailableProducts: "LAST",
                prefix: "NONE",
                runFlat: false
            })
            const isWheelCollection = (typeof wheelCollection !== 'undefined') ? wheelCollection : false

            const checkedInputs = Vue.ref(collectionConfig.pageFilters)
            const filtersLoading = Vue.ref(true)

            const showFilters = Vue.computed(() => {
                return filtersLoading.value
            })

            const promoSort = (a, b) => {
                if (!collectionConfig.sortKey.includes('PRICE')) return;
                const valueA = a?.node?.promoUnitPrice
                    ? Number(a?.node?.promoUnitPrice?.replace('$', ''))
                    : a?.node?.is_split
                        ? (Number(a?.node?.priceRange?.minVariantPrice?.amount) + Number(a?.node?.splitProduct?.node?.priceRange?.minVariantPrice?.amount)) / 2
                        : Number(a?.node?.priceRange?.minVariantPrice?.amount);
                const valueB = b?.node?.promoUnitPrice
                    ? Number(b?.node?.promoUnitPrice?.replace('$', ''))
                    : b?.node?.is_split
                        ? (Number(b?.node?.priceRange?.minVariantPrice?.amount) + Number(b?.node?.splitProduct?.node?.priceRange?.minVariantPrice?.amount)) / 2
                        : Number(b?.node?.priceRange?.minVariantPrice?.amount);
                if (isNaN(valueA) || isNaN(valueB)) return;
                return collectionConfig.descending ? valueB - valueA : valueA - valueB;
            }

            const searchAll = Vue.ref(false);

            const query = Vue.ref(new URLSearchParams(window.location.search).get('q'))

            const filters = Vue.reactive([]);

            const showSortUtility = Vue.ref(false);

            const isFilterDrawerOpen = Vue.ref(false)

            const expandedFilters = Vue.reactive({})

            const sortSelector = Vue.ref("RELEVANCE-ascending")
            const searchStore = window.search

            const vehicleSearch = window.vehicleSearch()

            const storeSelector = window.storeSelector()

            const pageInitiated = Vue.ref(false)

            const checkedSource = Vue.ref(false);

            const checkedLoad = Vue.ref(false);

            const listening = Vue.ref(false)

            const isLoadingMore = Vue.ref(false)
            const isPlpRefreshing = Vue.ref(false)
            const showLoadMoreBtn = Vue.ref(false)
            const hasClickedLoadMore = Vue.ref(false)

            // ── Cart state ──────────────────────────────────────────────────────────
            const cartAddingId = Vue.ref(null)
            const cartSuccessId = Vue.ref(null)
            let cartSuccessTimer = null
            const cartEnquiringId = Vue.ref(null)

            const setCartAdding = (productNode) => {
                cartAddingId.value = productNode?.id || null
                cartSuccessId.value = null
            }

            const setCartSuccess = (productNode) => {
                cartAddingId.value = null
                cartSuccessId.value = productNode?.id || null
                if (cartSuccessTimer) clearTimeout(cartSuccessTimer)
                cartSuccessTimer = setTimeout(() => {
                    cartSuccessId.value = null
                }, 2500)
            }

            const setCartIdle = () => {
                cartAddingId.value = null
                cartSuccessId.value = null
            }

            const isCartAdding = (productNode) => cartAddingId.value === productNode?.id
            const isCartSuccess = (productNode) => cartSuccessId.value === productNode?.id

            const setCartEnquiring = (productNode) => {
                cartEnquiringId.value = productNode?.id || null
            }
            const isCartEnquiring = (productNode) => cartEnquiringId.value === productNode?.id
            // ────────────────────────────────────────────────────────────────────────

            // ── Flip slot helpers ────────────────────────────────────────────────────
            const getFlipSlotAvailable = (productNode, slotIndex) => {
                const flip = productNode?.stock?.flip;
                if (!Array.isArray(flip) || flip.length <= slotIndex) return null;
                return flip[slotIndex]?.selectedAvailable ?? null;
            };

            const getFlipSlotLeadTime = (productNode, slotIndex) => {
                const flip = productNode?.stock?.flip;
                if (!Array.isArray(flip) || flip.length <= slotIndex) return null;
                return flip[slotIndex]?.leadTimeDays ?? null;
            };

            const getFlipSlotStatus = (productNode, slotIndex) => {
                const flip = productNode?.stock?.flip;
                if (!Array.isArray(flip) || flip.length <= slotIndex) return 'none';
                const slot = flip[slotIndex];
                if (!slot) return 'none';
                if (slot.selectedAvailable === true) return 'nearest';
                if (slot.nearestStore !== false && slot.nearestStore != null) return 'nearby';
                return 'none';
            };

            const getFlipSlotPrice = (productNode, slotIndex) => {
                const flip = productNode?.stock?.flip;
                if (!Array.isArray(flip) || flip.length <= slotIndex) return null;
                return flip[slotIndex]?.pricePerUnit ?? null;
            };

            const getFlipSlotNearbyStoreName = (productNode, slotIndex) => {
                const flip = productNode?.stock?.flip;
                if (!Array.isArray(flip) || flip.length <= slotIndex) return 'a nearby store';
                const locationGid = flip[slotIndex]?.nearestStore;
                if (!locationGid) return 'a nearby store';

                try {
                    const stores = JSON.parse(localStorage.getItem('storesUnder100') || '[]');
                    const match = stores.find(s => {
                        const id = String(s?.node?.id || '').replace('gid://shopify/Location/', '');
                        return id === String(locationGid);
                    });
                    if (match?.node?.name) return match.node.name;
                } catch (e) { }

                return 'a nearby store';
            };
            // ────────────────────────────────────────────────────────────────────────

            const availabilityFilterTools = Vue.reactive({
                availabilityFiltered: {
                    today: false,
                    week: false
                },
                availabilitySplice: {
                    today: [],
                    week: []
                },
                unavailList: {
                    today: [],
                    week: []
                },
                initialLength: 0,
                filteredLength: 0,
                adjustmentLength: 0,
                availabilityFilter(filterList, type) { //"today" or "week"
                    for (let i = 0; i < filterList.length; i++) {
                        this.unavailList[type].unshift({
                            idx: filterList[i],
                            product: store.products.edges[filterList[i]]
                        });
                        store.products.edges.splice(filterList[i], 1);
                    }
                    this.adjustmentLength = this.adjustmentLength + filterList.length;
                    this.filteredLength = store.products.edges.length;
                },
                availabilityLists(products) {
                    let diff = 7 * 24 * 60 * 60 * 1000;
                    const now = Date.now();
                    const weekSpliceList = []
                    const todaySpliceList = []
                    for (let i = this.filteredLength; i < products.edges.length; i++) {
                        if (!products?.edges?.[i]?.node?.stock?.leadDate) {
                            weekSpliceList.unshift(i);
                            todaySpliceList.unshift(i);
                        } else {
                            if (products?.edges?.[i]?.node?.stock?.qtyInStore < products?.edges?.[i]?.node?.stock?.qty) todaySpliceList.unshift(i);
                            if (diff < (Date.parse(products?.[i]?.node?.splitProduct?.node?.stock?.leadDate) - now)) weekSpliceList.unshift(i);
                            if (products?.edges?.[i]?.node.is_split) {
                                if (!products?.edges?.[i]?.node?.splitProduct?.node?.stock?.leadDate) {
                                    if (!weekSpliceList.includes(i)) weekSpliceList.unshift(i);
                                    if (!todaySpliceList.includes(i)) todaySpliceList.unshift(i);
                                } else {
                                    if (products?.edges?.[i]?.node?.splitProduct?.node?.stock?.qty < products?.edges?.[i]?.node?.splitProduct?.node?.stock?.qty) if (!todaySpliceList.includes(i)) todaySpliceList.unshift(index + reduction);
                                    if (diff < (Date.parse(products?.edges?.[i]?.node?.splitProduct?.node?.stock?.leadDate) - now)) if (!weekSpliceList.includes(i)) weekSpliceList.unshift(index + reduction);
                                }
                            }
                        }
                    }
                    this.initialLength = this.initialLength + (products.edges.length - this.filteredLength);
                    return {
                        week: weekSpliceList,
                        today: todaySpliceList
                    };
                },
                toggleAvailabilityFilter(type) { //"today" or "week"
                    if (!this.availabilityFiltered[type]) this.availabilityFilter(this.availabilitySplice[type], type);
                    else {
                        this.unavailList[type].forEach((item) => {
                            store.products.edges.splice(item.idx, 0, item.product);
                        })
                        this.unavailList[type] = [];
                        this.initialLength = store.products.edges.length;
                        this.filteredLength = 0;
                    }
                    this.availabilityFiltered[type] = !this.availabilityFiltered[type];
                },
                updateAvailabilityFilter(products) {
                    const spliceAdditions = this.availabilityLists(products);
                    this.availabilitySplice["today"] = spliceAdditions.today.concat(this.availabilitySplice["today"]);
                    this.availabilitySplice["week"] = spliceAdditions.week.concat(this.availabilitySplice["week"]);
                    if (this.availabilityFiltered.today) this.availabilityFilter(spliceAdditions.today, "today");
                    if (this.availabilityFiltered.week) this.availabilityFilter(spliceAdditions.week, "week");
                }
            });

            const store = window.collectionStore();
            const compareStore = window.compareStore ? window.compareStore() : null;
            compareStore?.loadFromStorage?.();
            const promoStore = window.promo();
            if (!promoStore._timerStarted) {
                promoStore._timerStarted = true;
                setInterval(() => { promoStore.currentTime = Date.now(); }, 1000);
            }
            const defaultTyreImage = window.defaultTyreImage;

            const products = Vue.computed(() => {
                return store.products
            })

            const showProduct = Vue.computed(() => {
                return store.products.edges ? false : true
            })

            const isCompareModalOpen = Vue.ref(false);
            const compareRef = compareStore || store;

            const canCompare = Vue.computed(() => (compareRef.selectedProducts || []).length >= 2);

            const toggleCompare = (product) => {
                const productId = product.id || product.node?.id;
                const existingIndex = (compareRef.selectedProducts || []).findIndex(p =>
                    (p.id || p.node?.id) === productId
                );

                if (existingIndex > -1) {
                    compareRef.selectedProducts.splice(existingIndex, 1);
                    compareStore?.persist?.();

                    if (compareRef.selectedProducts.length === 0) {
                        compareRef.isDrawerOpen = false;
                        compareStore?.persist?.();
                    }
                    return;
                }

                if (compareRef.selectedProducts.length >= 3) {
                    console.warn("Max 3 products allowed");
                    compareStore?.showCompareLimitDialog?.("You can only compare up to 3 tyres");
                    return;
                }

                compareRef.selectedProducts.push({
                    id: productId,
                    title: product.title,
                    price: product.priceRange.minVariantPrice.amount,
                    featured_image: product.images?.edges[0]?.node?.url || defaultTyreImage,
                    vendor: product.vendor,
                    available: product.availableForSale
                });

                compareStore?.openCompareDrawer?.();
            };

            const isInCompare = (product) => {
                const productId = product.id || product.node?.id;
                if (!productId) return false;
                return (compareRef.selectedProducts || []).some(p =>
                    (p.id || p.node?.id) === productId
                );
            };
            const closeDrawer = () => {
                compareRef.isDrawerOpen = false;
                compareStore?.persist?.();
            };

            const totalCompare = () => {
                return (compareRef.selectedProducts || []).length;
            };

            const clearAll = () => {
                compareRef.selectedProducts = [];
                compareRef.isDrawerOpen = false;
                compareStore?.persist?.();
            };

            const removeFromCompare = (productId) => {
                const index = (compareRef.selectedProducts || []).findIndex((p) => p.id === productId);
                if (index > -1) {
                    compareRef.selectedProducts.splice(index, 1);
                }

                if (!compareRef.selectedProducts.length) {
                    compareRef.isDrawerOpen = false;
                }
                compareStore?.persist?.();
            };

            const openCompareModal = () => {
                if (!canCompare.value) return;
                isCompareModalOpen.value = true;
                if (compareRef) {
                    compareRef.isCompareModalOpen = true
                    compareStore?.persist?.()
                }
            };

            const closeCompareModal = () => {
                isCompareModalOpen.value = false;
                if (compareRef) {
                    compareRef.isCompareModalOpen = false
                    compareStore?.persist?.()
                }
            };

            const closeHover = (event) => {
                const panel = event?.currentTarget?.closest('.productHoverPanel');
                if (panel) panel.classList.add('is-closed');
            };

            const resetHover = (event) => {
                const panel = event?.currentTarget?.querySelector('.productHoverPanel');
                panel?.classList.remove('is-closed');
            };

            const isFilterExpanded = (id) => {
                return !!expandedFilters[id]
            }

            const toggleFilterExpansion = (id) => {
                expandedFilters[id] = !expandedFilters[id]
            }

            const displayedFilterValues = (filter) => {
                if (!filter?.values) return []
                if (isFilterExpanded(filter.id)) return filter.values
                return filter.values.slice(0, 5)
            }

            const openFilterDrawer = () => {
                isFilterDrawerOpen.value = true
            }

            const closeFilterDrawer = () => {
                isFilterDrawerOpen.value = false
            }

            const toggleFilterDrawer = () => {
                isFilterDrawerOpen.value = !isFilterDrawerOpen.value
            }

            const quickFilters = Vue.computed(() => {
                const list = Object.values(filters)
                const firstFilter = list && list.length ? list[3] : null
                if (!firstFilter?.values) return []
                return firstFilter.values.slice(0, 6)
            })

            const isQuickFilterActive = (input) => {
                return collectionConfig.pageFilters.includes(input)
            }

            const toggleQuickFilter = (input) => {
                const idx = collectionConfig.pageFilters.indexOf(input)
                if (idx === -1) {
                    collectionConfig.pageFilters.push(input)
                } else {
                    collectionConfig.pageFilters.splice(idx, 1)
                }
                listening.value = true
                checkedInputs.value = [...collectionConfig.pageFilters]
            }

            const stock = window.stock()

            const getNormalizedSearchQuery = () => {
                const raw = String(query.value || '').trim()
                if (!raw) return raw
                if (searchStore && typeof searchStore.inputTest === 'function') {
                    return String(searchStore.inputTest(raw) || raw).trim()
                }
                return raw
            }

            const getSizeFiltersFromQuery = (inputQuery) => {
                const queryText = String(inputQuery || '').toUpperCase().trim()
                if (!queryText) return ''
                const match = queryText.match(/^(\d{3})\/(\d{2})R(\d{2})$/)
                if (!match) return ''
                const width = match[1]
                const aspect = match[2]
                const diameter = match[3]
                return `{productMetafield:{namespace:"wheel_tyre_spec",key:"width",value:"${width}"}},` +
                    `{productMetafield:{namespace:"tyre_spec",key:"aspect_ratio",value:"${aspect}"}},` +
                    `{productMetafield:{namespace:"wheel_tyre_spec",key:"rim_diameter",value:"${diameter}"}}`
            }

            const getStoredVehiclesForSelection = () => {
                try {
                    return JSON.parse(localStorage.getItem('vehicles') || '[]')
                } catch (e) {
                    return []
                }
            }

            const getSelectedVehicleForSelection = () => {
                const activeVehicleId = localStorage.getItem('activeVehicleId')
                const liveVehicles = Array.isArray(vehicleSearch.vehicles) ? vehicleSearch.vehicles : []
                const storedVehicles = getStoredVehiclesForSelection()
                if (!activeVehicleId) {
                    return null
                }

                const liveMatch = liveVehicles.find(v => String(v?.id) === String(activeVehicleId))
                if (liveMatch) return liveMatch

                return storedVehicles.find(v => String(v?.id) === String(activeVehicleId)) || null
            }


            let splitCheckSeq = 0

            const getCollectionProductType = () => {
                return window.location.pathname.includes('heel') ? 'wheel' : 'tyre'
            }

            const checkSplits = async () => {
                const getPatternTextFromTags = (tags) => {
                    if (!Array.isArray(tags)) return ''
                    const patternTag = tags.find(tag => typeof tag === 'string' && /^product\s*:/i.test(tag))
                    if (!patternTag) return ''
                    return patternTag.replace(/^product\s*:\s*/i, '').trim().toLowerCase()
                }
                const ensureNearestStore = () => {
                    if (storeSelector?.nearestStore) return
                    try {
                        const raw = localStorage.getItem('currentNearestStore')
                        const parsed = raw ? JSON.parse(raw) : null
                        if (parsed?.node?.id) {
                            storeSelector.nearestStore = parsed
                        }
                    } catch (e) { }
                }
                ensureNearestStore()
                const hasNearestStoreSelected = !!(storeSelector?.nearestStore || localStorage.getItem('currentNearestStore'))
                const selectedVehicle = getSelectedVehicleForSelection()
                if (!selectedVehicle) {
                    for (let i = 0; i < store.products?.edges?.length; i++) {
                        store.products.edges[i].node.fits = 'ALL'
                    }
                    if (hasNearestStoreSelected && localStorage.getItem('storesUnder100')) {
                        let qty = 4;
                        await stock.PLPStockRequest(qty);
                        availabilityFilterTools.updateAvailabilityFilter(store.products);
                    }
                    return
                }

                let fitment
                let frontFitment
                let rearFitment
                const productType = getCollectionProductType()
                if (productType === 'wheel') {
                    fitment = selectedVehicle?.fitmentInfo?.wheel_fitments?.[0] || null
                } else {
                    fitment = selectedVehicle?.fitmentInfo?.tyre_fitments?.[0] || null
                }
                if (fitment) {
                    if (productType === 'wheel') {
                        frontFitment = fitment.f_wheels || false
                        rearFitment = fitment.r_wheels || false
                    } else {
                        frontFitment = fitment.f_tyres || false
                        rearFitment = fitment.r_tyres || false
                    }
                } else {
                    fitment = productType === 'wheel'
                        ? selectedVehicle?.fitmentInfo?.tyre_fitments?.[0] || null
                        : selectedVehicle?.fitmentInfo?.wheel_fitments?.[0] || null
                    if (fitment) {
                        if (fitment.f_wheels || fitment.r_wheels) {
                            frontFitment = fitment.f_wheels || false
                            rearFitment = fitment.r_wheels || false
                        } else {
                            frontFitment = fitment.f_tyres || false
                            rearFitment = fitment.r_tyres || false
                        }
                    }
                }

                if (!fitment) {
                    for (let i = 0; i < store?.products?.edges?.length; i++) {
                        store.products.edges[i].node.fits = 'ALL'
                    }
                    if (hasNearestStoreSelected && localStorage.getItem('storesUnder100')) {
                        await stock.PLPStockRequest(4)
                        availabilityFilterTools.updateAvailabilityFilter(store.products);
                    }
                    return
                }
                if (fitment.is_split) {
                    let productSeries = ''
                    for (let i = 0; i < store?.products?.edges?.length; i++) {
                        if (typeof store.products.edges[i].node.is_split !== 'boolean') {
                            continue;
                        } else {
                            let pattern = store.products.edges[i].node?.tags.filter(tag => tag.includes('product:'))[0]
                            if (pattern) {
                                let splitFilters = ''
                                let frontMatches = []
                                let rearMatches = []
                                let prodMatches = []
                                let parsedMeta = []
                                try {
                                    parsedMeta = JSON.parse(store.products.edges[i].node.metafield.value)
                                } catch (e) {
                                    parsedMeta = [store.products.edges[i].node.metafield.value]
                                }
                                for (let s = 0; s < parsedMeta.length; s++) {
                                    prodMatches.push(parsedMeta[s])
                                }
                                for (let s = 0; s < frontFitment.matches.length; s++) {
                                    let parsed = []
                                    try {
                                        parsed = JSON.parse(frontFitment.matches[s])
                                    } catch (e) {
                                        parsed = [frontFitment.matches[s]]
                                    }
                                    for (let f = 0; f < parsed.length; f++) {
                                        frontMatches.push(parsed[f])
                                    }
                                }
                                for (let s = 0; s < rearFitment.matches.length; s++) {
                                    let parsed = []
                                    try {
                                        parsed = JSON.parse(rearFitment.matches[s])
                                    } catch (e) {
                                        parsed = [rearFitment.matches[s]]
                                    }
                                    for (let f = 0; f < parsed.length; f++) {
                                        rearMatches.push(parsed[f])
                                    }
                                }
                                if (prodMatches.some(element => frontMatches.includes(element))) {
                                    store.products.edges[i].node.fits = 'FRONT'
                                    for (let q = 0; q < rearMatches.length; q++) {
                                        splitFilters = `${splitFilters}{productMetafield:{namespace:"wts",key:"sf",value:"${rearMatches[q].replaceAll('/', 'x').replaceAll(' ', '_')}"}},`
                                    }
                                }
                                if (prodMatches.some(element => rearMatches.includes(element))) {
                                    store.products.edges[i].node.fits = 'REAR'
                                    for (let q = 0; q < frontMatches.length; q++) {
                                        splitFilters = `${splitFilters}{productMetafield:{namespace:"wts",key:"sf",value:"${frontMatches[q].replaceAll('/', 'x').replaceAll(' ', '_')}"}},`
                                    }
                                }
                                if (splitFilters == '') {
                                    continue;
                                }
                                if (collectionConfig.pageFilters[0]) {
                                    for (let fi = 0; fi < collectionConfig.pageFilters.length; fi++) {
                                        let input = JSON.parse(collectionConfig.pageFilters[fi])
                                        let valueString = ''
                                        if (typeof Object.values(input)[0] == "object") {
                                            for (let f = 0; f < Object.keys(Object.values(input)[0]).length; f++) {
                                                if (valueString == '') {
                                                    valueString = `${Object.keys(Object.values(input)[0])[f]}:"${Object.values(Object.values(input)[0])[f]}"`
                                                } else {
                                                    valueString = `${valueString},${Object.keys(Object.values(input)[0])[f]}:"${Object.values(Object.values(input)[0])[f]}"`
                                                }
                                            }
                                            if (splitFilters == '') {
                                                splitFilters = `{${Object.keys(input)[0]}:{${valueString}}}`
                                            } else {
                                                splitFilters = `${splitFilters},{${Object.keys(input)[0]}:{${valueString}}}`
                                            }
                                        } else {
                                            if (splitFilters == '') {
                                                splitFilters = `{${Object.keys(input)[0]}:"${Object.values(input)[0]}"}`
                                            } else {
                                                splitFilters = `${splitFilters},{${Object.keys(input)[0]}:"${Object.values(input)[0]}"}`
                                            }
                                        }
                                    }
                                }
                                splitFilters = `${splitFilters}{tag:"${pattern}"}`
                                productSeries = `${productSeries}
                                Product${i}: products(first:10, sortKey:${collectionConfig.sortKey}, reverse:${collectionConfig.descending}, filters:[${splitFilters}]) {
			                        edges {
				                        node {
					                        id
					                        title
					                        tags
					                        vendor
					                        handle
                                            availableForSale
					                        priceRange {
						                        minVariantPrice {
							                        amount
						                        }
						                        maxVariantPrice {
							                        amount
						                        }
					                        }
                                            collections(first:50) {
						                        edges {
							                        node {
                                                        id
                                                        title: metafield(namespace:"promotion",key:"title") {
									                        value
								                        }
                                                        type: metafield(namespace:"promotion",key:"type") {
                                                            value
                                                        }
                                                        value: metafield(namespace:"promotion",key:"value") {
                                                            value
                                                        }
                                                        colour: metafield(namespace:"promotion",key:"colour") {
                                                            value
                                                        }
                                                        end_date: metafield(namespace:"promotion",key:"end_date") {
                                                            value
                                                        }
                                                    }
                                                }
                                            }
				                        }
			                        }
			                        pageInfo {
				                        hasNextPage
				                        endCursor
			                        }
		                        }`
                            }
                        }
                    }
                    if (productSeries) {
                        const currentSplitSeq = ++splitCheckSeq
                        let queryString = `{
	                                collection(handle:"${collectionConfig.handle}") {
		                                ${productSeries}
	                                }
                                }`
                        const options = {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'X-Shopify-Storefront-Access-Token': shopifyConfig.PLP
                            },
                            body: JSON.stringify({ query: queryString })
                        };
                        await fetch(`${shopifyConfig.storeURL}/api/${shopifyConfig.apiVersion}/graphql.json`, options)
                            .then(response => {
                                if (response.status < 400) {
                                    return response.json()
                                } else {
                                    resolve('splitFail')
                                }
                            })
                            .then(async (object) => {
                                if (currentSplitSeq !== splitCheckSeq) {
                                    return
                                }
                                let now = Date.parse(new Date());
                                let spliceList = []
                                let entries = Object.entries(object?.data?.collection || {})
                                for (let v = 0; v < entries.length; v++) {
                                    const key = entries[v][0]
                                    const payload = entries[v][1]
                                    if (!String(key).startsWith('Product')) continue
                                    if (payload?.edges && payload.edges.length > 0) {
                                        const baseIdx = Number(String(key).replaceAll('Product', ''))
                                        const baseEdge = store.products?.edges?.[baseIdx]
                                        const baseNode = baseEdge?.node
                                        if (!baseNode) continue
                                        const basePatternText = getPatternTextFromTags(baseNode?.tags)
                                        const patternMatchedEdges = payload.edges.filter(edge => {
                                            return getPatternTextFromTags(edge?.node?.tags) === basePatternText
                                        })
                                        if (!patternMatchedEdges.length) {
                                            continue
                                        }
                                        for (let q = 0; q < patternMatchedEdges.length; q++) {
                                            if (q === 0) {
                                                if (baseEdge.node.fits == 'REAR') {
                                                    spliceList.unshift(baseIdx)
                                                } else {
                                                    baseEdge.node.is_split = true
                                                    baseEdge.node.splitProduct = patternMatchedEdges[q]
                                                    const splitNodeId = patternMatchedEdges[q].node.id
                                                    const cachedSplit = store.stockCache.filter(p => p.node.id == splitNodeId && p.node.stockExpiry > now)
                                                    if (cachedSplit.length > 0) {
                                                        baseEdge.node.splitProduct.node.stock = cachedSplit[0].node.stock
                                                        baseEdge.node.splitProduct.node.stockExpiry = cachedSplit[0].node.stockExpiry
                                                    }
                                                    baseEdge.node.sharedTags = baseEdge.node.tags.filter(tag => patternMatchedEdges[q].node.tags.includes(tag))
                                                    promoStore.calculatePromoValues(baseEdge.node)
                                                    let cachedStock = store.stockCache.filter(prod => prod.node.id == patternMatchedEdges[q].node.id && prod.node.stockExpiry > now)
                                                    if (cachedStock.length > 0) {
                                                        baseEdge.node.stockExpiry = cachedStock[0].node.stockExpiry
                                                        baseEdge.node.stock = cachedStock[0].node.stock
                                                    }
                                                }
                                            } else {
                                                //TODO: Handle multi split
                                                let newProd = baseEdge
                                                if (!newProd?.node) continue
                                                newProd.node.is_split = true
                                                newProd.node.splitProduct = patternMatchedEdges[q]
                                                const splitNodeId2 = patternMatchedEdges[q].node.id
                                                const cachedSplit2 = store.stockCache.filter(p => p.node.id == splitNodeId2 && p.node.stockExpiry > now)
                                                if (cachedSplit2.length > 0) {
                                                    newProd.node.splitProduct.node.stock = cachedSplit2[0].node.stock
                                                    newProd.node.splitProduct.node.stockExpiry = cachedSplit2[0].node.stockExpiry
                                                }
                                                newProd.node.sharedTags = baseEdge.node.tags.filter(tag => patternMatchedEdges[q].node.tags.includes(tag))
                                                promoStore.calculatePromoValues(newProd.node)
                                                let cachedStock = store.stockCache.filter(prod => prod.node.id == patternMatchedEdges[q].node.id && prod.node.stockExpiry > now)
                                                if (cachedStock.length > 0) {
                                                    newProd.node.stockExpiry = cachedStock[0].node.stockExpiry
                                                    newProd.node.stock = cachedStock[0].node.stock
                                                }
                                                store.products.edges.push(newProd);
                                            }
                                        }
                                    }
                                }
                                for (let v = 0; v < spliceList.length; v++) {
                                    store.products.edges.splice(spliceList[v], 1)
                                }
                                if (hasNearestStoreSelected) {
                                    await stock.PLPStockRequest(2);
                                    availabilityFilterTools.updateAvailabilityFilter(store.products);
                                }
                            })
                            .catch(err => {
                                console.log('Error: failed to fetch split fitments')
                                console.log(`Error: ${err}`)
                            })
                    } else {
                        if (hasNearestStoreSelected) {
                            await stock.PLPStockRequest(2);
                            availabilityFilterTools.updateAvailabilityFilter(store.products);
                        }
                    }
                } else {
                    for (let i = 0; i < store?.products?.edges?.length; i++) {
                        store.products.edges[i].node.fits = 'ALL'
                    }
                    if (hasNearestStoreSelected) {
                        await stock.PLPStockRequest(4);
                        availabilityFilterTools.updateAvailabilityFilter(store.products);
                    }
                }
            }

            //Call product array for collection
            const getCollection = async () => {
                if (query.value) {
                    const normalizedQuery = getNormalizedSearchQuery()
                    if (window.name) {
                        localStorage.setItem(`${window.name}prevCollectionConfig`, JSON.stringify(collectionConfig))
                    }
                    let splitString = ''
                    const selectedVehicle = getSelectedVehicleForSelection()
                    if (selectedVehicle?.fitmentInfo?.tyre_fitments?.[0]?.is_split || selectedVehicle?.fitmentInfo?.wheel_fitments?.[0]?.is_split) {
                        splitString = `metafield(namespace:"wts",key:"sf") {
  						value
  					}`
                    }
                    let filters = collectionConfig.vehicleFilters;
                    let stringFilters = ''
                    const normalizeFilterValue = (value) => {
                        const normalized = String(value || '').replaceAll('/', 'x').replaceAll(' ', '_');
                        const stripped = normalized.replace(/_(\d+)[A-Z]+$/i, '_$1');
                        return stripped !== normalized ? [normalized, stripped] : [normalized];
                    };
                    const expandFilterValues = (entry) => {
                        if (!entry) return [];
                        const asString = String(entry).trim();
                        if (asString.startsWith('[')) {
                            try {
                                const parsed = JSON.parse(asString);
                                if (Array.isArray(parsed)) {
                                    return parsed.flatMap((val) => normalizeFilterValue(val));
                                }
                            } catch (e) { }
                        }
                        return normalizeFilterValue(asString);
                    };

                    for (i = 0; i < filters.length; i++) {
                        const values = expandFilterValues(filters[i]);
                        for (let q = 0; q < values.length; q++) {
                            if (stringFilters === '') {
                                stringFilters = `{productMetafield:{namespace:"wts",key:"sf",value:"${values[q]}"}}`
                            } else {
                                stringFilters = `${stringFilters},{productMetafield:{namespace:"wts",key:"sf",value:"${values[q]}"}}`
                            }
                        }
                    }
                    const serviceKey = /alignment/i.test(normalizedQuery) ? 'wa' : (/puncture/i.test(normalizedQuery) ? 'pr' : null);
                    if (searchAll.value || serviceKey) {
                        stringFilters = '';
                    }
                    const serviceVehicleHandle = serviceKey
                        ? String(selectedVehicle?.additions?.[serviceKey]?.url || '').split('/products/').pop() || null
                        : null;
                    for (i = 0; i < collectionConfig.pageFilters.length; i++) {
                        let input = JSON.parse(collectionConfig.pageFilters[i])
                        let valueString = ''
                        if (typeof Object.values(input)[0] == "object") {
                            for (let f = 0; f < Object.keys(Object.values(input)[0]).length; f++) {
                                if (valueString == '') {
                                    valueString = `${Object.keys(Object.values(input)[0])[f]}:"${Object.values(Object.values(input)[0])[f]}"`
                                } else {
                                    valueString = `${valueString},${Object.keys(Object.values(input)[0])[f]}:"${Object.values(Object.values(input)[0])[f]}"`
                                }
                            }
                            if (stringFilters == '') {
                                stringFilters = `{${Object.keys(input)[0]}:{${valueString}}}`
                            } else {
                                stringFilters = `${stringFilters},{${Object.keys(input)[0]}:{${valueString}}}`
                            }
                        } else {
                            if (stringFilters == '') {
                                stringFilters = `{${Object.keys(input)[0]}:"${Object.values(input)[0]}"}`
                            } else {
                                stringFilters = `${stringFilters},{${Object.keys(input)[0]}:"${Object.values(input)[0]}"}`
                            }
                        }
                    }
                    if (!searchAll.value) {
                        const sizeFilters = getSizeFiltersFromQuery(normalizedQuery)
                        if (sizeFilters) {
                            stringFilters = stringFilters ? `${stringFilters},${sizeFilters}` : sizeFilters
                        }
                    }
                    let queryString = `{
                    search(query:"${normalizedQuery}", first:${collectionConfig.pageLength}${collectionConfig.cursor}, prefix:${collectionConfig.prefix}, types:[PRODUCT], sortKey:${collectionConfig.sortKey}, reverse:${collectionConfig.descending}, unavailableProducts:${collectionConfig.unavailableProducts}, productFilters:[${stringFilters}]) {
                        edges {
			                node {
				                ... on Product {
					                id
					                title
                                    productType
					                tags
                					vendor
				                	handle
                					availableForSale
                                    variants(first:1) {
                                        edges {
                                            node {
                                                id
                                            }
                                        }
                                    }
				                	images(first:1) {
                						edges {
				                			node {
								                altText
                								height
				                				width
								                url
                							}
				                		}
					                }
                                    collections(first:50) {
						                edges {
							                node {
                                                id
                                                title: metafield(namespace:"promotion",key:"title") {
                									value
								                }
                                                type: metafield(namespace:"promotion",key:"type") {
                                                    value
                                                }
                                                value: metafield(namespace:"promotion",key:"value") {
                                                    value
                                                }
                                                colour: metafield(namespace:"promotion",key:"colour") {
                                                    value
                                                }
                                                end_date: metafield(namespace:"promotion",key:"end_date") {
                                                    value
                                                }
                                            }
                                        }
                                    }
                                    ${splitString}
                                    bestDealText: metafield(namespace:"price",key:"best_deal_text") {
                                        value
                                    }
                					priceRange {
				                		minVariantPrice {
							                amount
                						}
				                		maxVariantPrice {
                							amount
				                		}
                					}
				                }
                			}
		                }
                		pageInfo {
			                hasNextPage
			                endCursor
		                }
                    }
                }`
                    const options = {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Shopify-Storefront-Access-Token': shopifyConfig.PLP
                        },
                        body: JSON.stringify({ query: queryString })
                    };
                    const collectionCall = new Promise(function (resolve, reject) {
                        fetch(`${shopifyConfig.storeURL}/api/${shopifyConfig.apiVersion}/graphql.json`, options)
                            .then(response => {
                                if (response.status < 400) {
                                    return response.json()
                                } else {
                                    resolve('PLPFail')
                                }
                            })
                            .then(object => {
                                collectionConfig.hasNextPage = object.data.search.pageInfo.hasNextPage
                                if (object.data.search.pageInfo.hasNextPage) {
                                    collectionConfig.cursor = `, after:"${object.data.search.pageInfo.endCursor}"`
                                } else {
                                    collectionConfig.cursor = ''
                                }
                                if (object?.data?.search?.edges) {
                                    for (let i = 0; i < object.data.search.edges.length; i++) {
                                        if (object?.data?.search?.edges[i]?.node?.priceRange?.minVariantPrice?.amount) {
                                            object.data.search.edges[i].node.price = promoStore.priceFormat(
                                                object.data.search.edges[i].node.priceRange.minVariantPrice.amount
                                            )
                                        }
                                        if (enableBestPriceXMonths) {
                                            const bestDealTextRaw = object?.data?.search?.edges[i]?.node?.bestDealText?.value;
                                            if (bestDealTextRaw) {
                                                try {
                                                    const bdt = JSON.parse(bestDealTextRaw);
                                                    if (bdt.best_deal_text) {
                                                        object.data.search.edges[i].node.priceDropData = {
                                                            label: bdt.best_deal_text
                                                        };
                                                    }
                                                } catch (e) { }
                                            }
                                        }
                                    }
                                }
                                resolve(object);
                            })
                            .catch(err => {
                                console.log('Error: failed to fetch products')
                                console.log(`Error: ${err}`)
                            })
                    })
                    let now = Date.parse(new Date())
                    const collectionResponse = await collectionCall
                    if (!searchAll.value && serviceKey && selectedVehicle && collectionResponse?.data?.search?.edges) {
                        collectionResponse.data.search.edges = serviceVehicleHandle
                            ? collectionResponse.data.search.edges.filter(edge => edge?.node?.handle === serviceVehicleHandle)
                            : [];
                    }
                    if (collectionResponse?.data?.search?.edges) {
                        for (let i = 0; i < collectionResponse.data.search.edges.length; i++) {
                            let cachedStock = store.stockCache.filter(prod => prod.node.id == collectionResponse.data.search.edges[i].node.id && prod.node.stockExpiry > now)
                            if (cachedStock.length > 0) {
                                collectionResponse.data.search.edges[i].node.stockExpiry = cachedStock[0].node.stockExpiry
                                collectionResponse.data.search.edges[i].node.stock = cachedStock[0].node.stock
                            }

                            collectionResponse.data.search.edges[i].node.is_split = !!collectionResponse.data.search.edges[i].node?.splitProduct?.node || !!collectionResponse.data.search.edges[i].node?.is_split
                            promoStore.calculatePromoValues(collectionResponse.data.search.edges[i].node)

                        }
                    }
                    return collectionResponse
                } else {
                    console.error('No search query submitted')
                }

            }

            //Call filters that apply to this page and the counts for each filter value
            const getFilters = async () => {
                const isServiceSearchQuery = /alignment|puncture/i.test(getNormalizedSearchQuery());
                const vehicleFilters = isServiceSearchQuery ? [] : [...new Set((collectionConfig.vehicleFilters || []).filter(Boolean))]
                const filterParts = []

                for (let i = 0; i < vehicleFilters.length; i++) {
                    filterParts.push(`{productMetafield:{namespace:"wts",key:"sf",value:"${vehicleFilters[i]}"}}`)
                }
                for (let i = 0; i < collectionConfig.pageFilters.length; i++) {
                    let input = JSON.parse(collectionConfig.pageFilters[i])
                    let valueString = ''
                    if (typeof Object.values(input)[0] == "object") {
                        for (let f = 0; f < Object.keys(Object.values(input)[0]).length; f++) {
                            if (valueString == '') {
                                valueString = `${Object.keys(Object.values(input)[0])[f]}:"${Object.values(Object.values(input)[0])[f]}"`
                            } else {
                                valueString = `${valueString},${Object.keys(Object.values(input)[0])[f]}:"${Object.values(Object.values(input)[0])[f]}"`
                            }
                        }
                        filterParts.push(`{${Object.keys(input)[0]}:{${valueString}}}`)
                    } else {
                        filterParts.push(`{${Object.keys(input)[0]}:"${Object.values(input)[0]}"}`)
                    }
                }
                if (!isWheelCollection && vehicleFilters.length > 0) {
                    filterParts.push(`{productMetafield:{namespace:"tyre_spec",key:"run_flat",value:"${collectionConfig.runFlat}"}}`)
                }
                let stringFilters = filterParts.join(',')
                if (stringFilters.length > 0) {
                    stringFilters = `${stringFilters},{available:true},{available:false}`
                } else {
                    stringFilters = `{available:true},{available:false}`
                }
                const normalizedQuery = getNormalizedSearchQuery()
                let queryString = `{
                    search(
                        query:"${normalizedQuery}",
                        first:1,
                        prefix:${collectionConfig.prefix},
                        types:[PRODUCT],
                        unavailableProducts:${collectionConfig.unavailableProducts},
                        productFilters:[${stringFilters}]
                    ) {
                        productFilters {
                            id
                            label
                            values {
                                id
                                label
                                count
                                input
                            }
                        }
                    }
                }`
                const options = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Shopify-Storefront-Access-Token': shopifyConfig.PLP
                    },
                    body: JSON.stringify({ query: queryString })
                };
                const filterCall = new Promise(function (resolve, reject) {
                    fetch(`${shopifyConfig.storeURL}/api/${shopifyConfig.apiVersion}/graphql.json`, options)
                        .then(response => {
                            if (response.status < 400) {
                                return response.json()
                            } else {
                                resolve('FilterFail')
                            }
                        })
                        .then(object => {
                            resolve(object);
                            reject('FilterFail');
                        })
                        .catch(err => {
                            console.log('Error: failed to fetch filters')
                            console.log(`Error: ${err}`)
                        })
                })
                const filterResponse = await filterCall;
                return filterResponse;
            }

            //Add next pagination of collection to product array when user scrolls more than halfway down the page
            const infiniteScroll = async () => {
                const scrollBottom = window.innerHeight + window.scrollY;
                const pageHeight = document.documentElement.scrollHeight;

                if (scrollBottom >= pageHeight - 200 && collectionConfig.hasNextPage && !isLoadingMore.value) {
                    isLoadingMore.value = true
                    await getCollection().then(async (prodUpdate) => {
                        if (prodUpdate !== 'PLPFail') {
                            const newEdges = prodUpdate.data.search.edges || [];
                            if (!store.products.edges) {
                                store.products.edges = newEdges;
                            } else {
                                store.products.edges = store.products.edges.concat(newEdges);
                            }
                            await checkSplits()
                            if (collectionConfig.sortKey.includes('PRICE')) store.products.edges.sort(promoSort);
                        }
                    }).finally(() => {
                        isLoadingMore.value = false
                        Vue.nextTick(() => {
                            document.removeEventListener('scroll', infiniteScroll)
                            if (collectionConfig.hasNextPage) {
                                document.addEventListener('scroll', infiniteScroll)
                            }
                        })
                    });
                }
            };

            const loadMore = async () => {
                if (!collectionConfig.hasNextPage || isLoadingMore.value) return
                hasClickedLoadMore.value = true
                isLoadingMore.value = true

                await getCollection().then(async (prodUpdate) => {
                    if (prodUpdate !== 'PLPFail') {
                        const newEdges = prodUpdate.data.search.edges || []
                        store.products.edges = store.products.edges
                            ? store.products.edges.concat(newEdges)
                            : newEdges
                        await checkSplits()
                        if (collectionConfig.sortKey.includes('PRICE')) store.products.edges.sort(promoSort);
                    }
                }).finally(() => {
                    isLoadingMore.value = false
                    // Switch to infinite scroll for all subsequent pages
                    if (collectionConfig.hasNextPage) {
                        document.addEventListener('scroll', infiniteScroll)
                    }
                })
            }

            hasClickedLoadMore.value = false
            document.removeEventListener('scroll', infiniteScroll)
            //Product call and filter call to be used when page first loads or the filters are changed
            const newProdSearch = async () => {
                availabilityFilterTools.availabilityFiltered.today = false;
                availabilityFilterTools.availabilityFiltered.week = false;
                availabilityFilterTools.availabilitySplice.today = [];
                availabilityFilterTools.availabilitySplice.week = [];
                availabilityFilterTools.unavailList.today = [];
                availabilityFilterTools.unavailList.week = [];
                availabilityFilterTools.initialLength = 0;
                availabilityFilterTools.filteredLength = 0;
                availabilityFilterTools.adjustmentLength = 0;
                showSortUtility.value = false;
                if (checkedSource.value) {
                    checkedLoad.value = true;
                }
                if (localStorage.getItem('searchSizeFilters')) {
                    try {
                        let searchResiduals = JSON.parse(localStorage.getItem('searchSizeFilters'));
                        collectionConfig.pageFilters = searchResiduals;
                        localStorage.removeItem('searchSizeFilters');
                    } catch (err) {
                        console.log(`Search storage error: ${err}`)
                    }
                }
                hasClickedLoadMore.value = false
                showLoadMoreBtn.value = false
                document.removeEventListener('scroll', infiniteScroll)
                isPlpRefreshing.value = true
                filtersLoading.value = true
                if (localStorage.getItem('searchWidgetFilters')) {
                    try {
                        let widgFilters = JSON.parse(localStorage.getItem('searchWidgetFilters'));
                        for (let i = 0; i < widgFilters.length; i++) {
                            if (typeof widgFilters[i] == 'object') {
                                widgFilters[i] = JSON.stringify(widgFilters[i]);
                            }
                            if (!collectionConfig.pageFilters.includes(widgFilters[i])) {
                                collectionConfig.pageFilters.push(widgFilters[i]);
                            }
                        }
                    } catch (err) {
                        console.error(`Error loading dropdown size filters: ${err}`);
                    }
                }
                try {
                    const vehicle = getSelectedVehicleForSelection()
                    if (vehicle && !localStorage.getItem('searchWidgetFilters')) {

                        let fitment = []
                        if (vehicle.fitmentInfo?.tyre_fitments[0]?.f_tyres) {
                            fitment.push(vehicle.fitmentInfo.tyre_fitments[0].f_tyres)
                        }
                        if (vehicle.fitmentInfo?.tyre_fitments[0]?.is_split && vehicle.fitmentInfo?.tyre_fitments[0]?.r_tyres) {
                            fitment.push(vehicle.fitmentInfo.tyre_fitments[0].r_tyres)
                        }
                        if (vehicle.fitmentInfo?.wheel_fitments[0]?.f_wheels) {
                            fitment.push(vehicle.fitmentInfo.wheel_fitments[0].f_wheels)
                        }
                        if (vehicle.fitmentInfo?.wheel_fitments[0]?.is_split && vehicle.fitmentInfo?.wheel_fitments[0]?.f_wheels) {
                            fitment.push(vehicle.fitmentInfo.wheel_fitments[0].r_wheels)
                        }

                        collectionConfig.vehicleFilters = []

                        if (fitment && fitment.length > 0) {
                            for (let i = 0; i < fitment.length; i++) {
                                if (fitment[i]?.matches && fitment[i].matches?.length > 0) {
                                    collectionConfig.vehicleFilters = collectionConfig.vehicleFilters.concat(fitment[i].matches)
                                }
                            }
                        }

                        /*if ((new Date().getFullYear() - vehicleSearch.vehicleAgeReversal) < vehicle.manufactureYear) {
                            collectionConfig.descending = true
                            sortSelector.value = 'PRICE-descending'
                        } else {
                            sortSelector.value = 'PRICE-ascending'
                        }
                        collectionConfig.sortKey = 'PRICE'*/
                        localStorage.removeItem('searchWidgetFilters')
                    } else {
                        collectionConfig.vehicleFilters = []
                    }

                    await getCollection().then(async (collection) => {
                        if (collection != 'PLPFail') {
                            Object.assign(store.products, collection.data.search);
                            await checkSplits()
                            if (collectionConfig.sortKey.includes('PRICE')) store.products.edges.sort(promoSort);
                        }
                    })

                    await getFilters().then(newFilters => {
                        if (newFilters != 'FilterFail') {
                            let productFilters = newFilters?.data?.search?.productFilters || newFilters?.data?.collection?.products?.filters || []
                            let availIndex = productFilters.findIndex(filter => filter.id == 'filter.available')
                            if (availIndex > -1) {
                                productFilters.splice(availIndex, 1)
                            }
                            let fullIndex = productFilters.findIndex(filter => filter.id == 'filter.p.m.wts.sf')
                            if (fullIndex > -1) {
                                productFilters.splice(fullIndex, 1)
                            }
                            let tagIndex = productFilters.findIndex(filter => filter.id == 'filter.p.tag')
                            if (tagIndex > -1) {
                                productFilters.splice(tagIndex, 1)
                            }
                            if (localStorage.getItem('searchWidgetFilters')) {
                                let aspectIndex = productFilters.findIndex(filter => filter.id == 'filter.p.m.tyre_spec.aspect_ratio')
                                if (aspectIndex > -1) {
                                    productFilters.splice(aspectIndex, 1)
                                }
                                let rimIndex = productFilters.findIndex(filter => filter.id == 'filter.p.m.wheel_tyre_spec.rim_diameter')
                                if (rimIndex > -1) {
                                    productFilters.splice(rimIndex, 1)
                                }
                                let widthIndex = productFilters.findIndex(filter => filter.id == 'filter.p.m.wheel_tyre_spec.width')
                                if (widthIndex > -1) {
                                    productFilters.splice(widthIndex, 1)
                                }
                            }
                            for (let i = 0; i < productFilters.length; i++) {
                                productFilters[i].values = (productFilters[i].values || []).filter(val => val.count > 0);
                            }
                            productFilters = productFilters.filter(filt => (filt.values || []).length > 0)
                            let splicers = []
                            for (let i = 0; i < productFilters.length; i++) {
                                if ((productFilters[i].values || []).reduce((accumulator, currentValue) => accumulator + currentValue.count, 0) == 0) {
                                    splicers.unshift(i);
                                }
                            }
                            for (let i = 0; i < splicers.length; i++) {
                                productFilters.splice(splicers[i], 1);
                            }
                            filters.splice(0, filters.length)
                            for (let i = 0; i < productFilters.length; i++) {
                                filters.push(productFilters[i]);
                            }
                            checkedLoad.value = false;
                            checkedSource.value = false;
                            listening.value = true;
                        }
                    })

                    const hasVehicleOrSize = !!localStorage.getItem('activeVehicleId') || !!localStorage.getItem('selectedSizeDisplay')
                    if (hasVehicleOrSize) {
                        document.addEventListener('scroll', infiniteScroll)
                    } else {
                        showLoadMoreBtn.value = collectionConfig.hasNextPage
                    }
                } finally {
                    filtersLoading.value = false
                    isPlpRefreshing.value = false
                }
            }

            //Check for vehicle details and fitment filters when page first loads then trigger initial product call
            Vue.onMounted(() => {
                newProdSearch()
            })

            //Watch for change in sort from dropdown and trigger new product call if changed
            Vue.watch(sortSelector, (newValue) => {
                collectionConfig.sortKey = newValue.split('-')[0]
                if (newValue.split('-')[1] == 'ascending') {
                    collectionConfig.descending = false
                } else if (newValue.split('-')[1] == 'descending') {
                    collectionConfig.descending = true
                }
                collectionConfig.cursor = ''
                collectionConfig.hasNextPage = true
                newProdSearch()
            })

            Vue.watch(vehicleSearch.vehicles, () => {
                collectionConfig.cursor = ''
                collectionConfig.hasNextPage = true
                newProdSearch()
            })

            Vue.watch(checkedInputs, (newValue) => {
                checkedSource.value = true;
                collectionConfig.pageFilters = newValue;
                collectionConfig.cursor = ''
                collectionConfig.hasNextPage = true;
                if (listening.value) {
                    setTimeout(newProdSearch, 1500)
                }
                listening.value = false
            })

            const fitmentStore = window.fitmentStore ? window.fitmentStore() : null
            const selectedFitment = Vue.ref(fitmentStore?.selectedFitment || null)
            if (fitmentStore) {
                Vue.watch(
                    () => fitmentStore.selectedFitment,
                    (val) => {
                        selectedFitment.value = val || null
                    },
                    { immediate: true }
                )
            }

            const activePickerId = Vue.ref(null)
            const pickerQuantities = Vue.reactive({})

            const splitQuantities = Vue.reactive({})

            const searchAllProducts = () => {
                searchAll.value = true;
                newProdSearch();
            }

            const clearAllFilters = () => {
                collectionConfig.pageFilters = [];
                checkedInputs.value = [];
                listening.value = false;
                collectionConfig.cursor = '';
                collectionConfig.hasNextPage = true;
                localStorage.removeItem('searchSizeFilters');
                try {
                    if (fitmentStore) {
                        fitmentStore.selectedFitment = null;
                    }
                } catch (e) { }
                newProdSearch();
            };

            const getActiveVehicle = () => {
                return getSelectedVehicleForSelection()
            }

            const getFitmentLabel = (fitment) => {
                return fitment?.full_desc || fitment?.desc || fitment?.display_name || ''
            }

            const getActiveFitment = () => {
                const vehicle = getActiveVehicle()
                if (!vehicle) return null

                if (selectedFitment.value) {
                    const frontLabel = selectedFitment.value.fullSize || selectedFitment.value.size || ''
                    const rearLabel = selectedFitment.value.fullRearSize || selectedFitment.value.rearSize || ''
                    if (selectedFitment.value.isSplit) {
                        return {
                            isSplit: true,
                            front: frontLabel,
                            rear: rearLabel
                        }
                    }
                    return {
                        isSplit: false,
                        single: frontLabel
                    }
                }

                const tyreFitment = vehicle.fitmentInfo?.tyre_fitments?.[0]
                if (!tyreFitment) {
                    const wheelFitment = vehicle.fitmentInfo?.wheel_fitments?.[0]
                    if (!wheelFitment) return null
                    if (wheelFitment.is_split) {
                        return {
                            isSplit: true,
                            front: getFitmentLabel(wheelFitment.f_wheels),
                            rear: getFitmentLabel(wheelFitment.r_wheels)
                        }
                    }
                    return {
                        isSplit: false,
                        single: getFitmentLabel(wheelFitment.f_wheels)
                    }
                }
                if (tyreFitment.is_split) {
                    return {
                        isSplit: true,
                        front: getFitmentLabel(tyreFitment.f_tyres),
                        rear: getFitmentLabel(tyreFitment.r_tyres)
                    }
                }
                return {
                    isSplit: false,
                    single: getFitmentLabel(tyreFitment.f_tyres)
                }


            }

            const isVehicleSplit = () => {
                const fitment = getActiveFitment()
                return !!fitment?.isSplit
            }

            const getVariantId = (variantId) => {
                if (!variantId) return null
                if (typeof variantId === 'string' && variantId.includes('/')) {
                    return variantId.split('/').pop()
                }
                return variantId
            }

            const cartToolsStore = window.cartTools();

            const getCartId = (cartTools) => {
                if (!cartTools) return null
                const cartData = cartTools.cartData?.value || cartTools.cartData || null
                if (cartData?.id) return cartData.id
                try {
                    const raw = localStorage.getItem('cartData')
                    const parsed = raw ? JSON.parse(raw) : null
                    return parsed?.id || null
                } catch (e) { }
                return null
            }

            const isTyreProduct = (productNode) => {
                const typeStr = String(productNode?.productType || productNode?.type || productNode?.category?.name || '').toLowerCase()
                return typeStr.includes('tyre') || typeStr.includes('tire')
            }

            const addVariantToCart = async (variantId, qty, promo, productNode) => {
                if (!cartToolsStore || !variantId || !qty) return
                const isTyre = productNode ? isTyreProduct(productNode) : false
                const cartId = getCartId(cartToolsStore)
                try {
                    if (cartId) {
                        await cartToolsStore.cartAdd(variantId, qty, cartId, promo, isTyre)
                    } else {
                        await cartToolsStore.newCart(variantId, qty, vehicleSearch.vehicles, storeSelector.location, promo, isTyre)
                    }
                } catch (e) {
                    await cartToolsStore.newCart(variantId, qty, vehicleSearch.vehicles, storeSelector.location, promo, isTyre)
                }
                cartToolsStore.openCheckout = false
                cartToolsStore.showCart = true
            }

            const ensurePickerQty = (productNode) => {
                const key = productNode?.id
                if (!key) return null
                if (!pickerQuantities[key]) {
                    const flip = productNode?.stock?.flip
                    let defaultQty = 4
                    if (Array.isArray(flip) && flip.length > 0) {
                        for (let i = Math.min(3, flip.length - 1); i >= 0; i--) {
                            if (getFlipSlotStatus(productNode, i) === 'nearest') {
                                defaultQty = i + 1
                                break
                            }
                        }
                    }
                    pickerQuantities[key] = defaultQty
                }
                return pickerQuantities[key]
            }

            const getPickerQty = (productNode) => {
                return ensurePickerQty(productNode) || 1
            }

            const setPickerQty = (productNode, qty) => {
                const key = productNode?.id
                if (!key) return
                pickerQuantities[key] = qty
            }

            const goToEnquiryPage = () => {
                const url = (typeof window.getEnquiryPageUrl === 'function')
                    ? window.getEnquiryPageUrl()
                    : `${String(shopifyConfig?.storeURL || window.location.origin || '').replace(/\/$/, '')}/pages/contact`
                window.location.href = url
            }

            const addServiceProductToCart = async (productNode) => {
                if (!productNode) return
                setCartAdding(productNode)
                const variantId = getVariantId(productNode?.variants?.edges?.[0]?.node?.id)
                try {
                    if (variantId) {
                        await addVariantToCart(variantId, 1, false)
                        setCartSuccess(productNode)
                    } else {
                        setCartIdle()
                    }
                } catch (e) {
                    setCartIdle()
                }
            }

            const openQuantityPicker = (productNode) => {
                if (!productNode?.id) return
                if (isServiceProduct(productNode)) {
                    addServiceProductToCart(productNode)
                    return
                }
                if (getStockStatus(productNode) === 'out') {
                    const flip = productNode?.stock?.flip
                    const hasFlipAvailability = Array.isArray(flip) && flip.some((_, idx) => {
                        const slotStatus = getFlipSlotStatus(productNode, idx)
                        return slotStatus === 'nearest' || slotStatus === 'nearby'
                    })
                    if (!hasFlipAvailability) {
                        goToEnquiryPage()
                        return
                    }
                }
                ensurePickerQty(productNode)
                activePickerId.value = productNode.id
            }

            const closeQuantityPicker = () => {
                activePickerId.value = null
            }

            const isPickerOpen = (productNode) => {
                if (!productNode?.id) return false
                return activePickerId.value === productNode.id
            }

            const ensureSplitQty = (productNode) => {
                const key = productNode?.id
                if (!key) return null
                if (!splitQuantities[key]) {
                    splitQuantities[key] = { front: 2, rear: 2 }
                }
                return splitQuantities[key]
            }

            const getSplitQty = (productNode, axle) => {
                const entry = ensureSplitQty(productNode)
                if (!entry) return 0
                return axle === 'rear' ? entry.rear : entry.front
            }

            const updateSplitQty = async (productNode, axle, delta) => {
                const entry = ensureSplitQty(productNode)
                if (!entry) return
                const current = axle === 'rear' ? entry.rear : entry.front
                const nextValue = Math.max(0, current + delta)
                let nearbyLocations = [];
                if (localStorage.getItem('storesUnder100')) {
                    try {
                        let parsedStores = JSON.parse(localStorage.getItem('storesUnder100'));
                        nearbyLocations = nearbyLocations.concat(parsedStores);
                    } catch (err) {
                        console.error(`Error retrieving nearby stores: ${err}`)
                    }
                }
                let requestLocations = nearbyLocations.map(location => location.node.id.replaceAll("gid://shopify/Location/", ""));
                requestLocations.unshift(storeSelector.nearestStore.node.id.replaceAll("gid://shopify/Location/", ""))
                if (axle === 'rear') {
                    entry.rear = nextValue;
                    if (nextValue > 0) {
                        let stockUpdate = await stock.requestStock([productNode.splitProduct.node.id.replaceAll("gid://shopify/Product/", "")], requestLocations, nextValue, true);
                        const locStock = stockUpdate?.[0]?.locations?.[0];
                        productNode.splitProduct.node.stock.leadDays = locStock?.availableDays;
                        productNode.splitProduct.node.stock.available = locStock?.available;
                    }
                } else {
                    entry.front = nextValue;
                    if (nextValue > 0) {
                        let stockUpdate = await stock.requestStock([productNode.id.replaceAll("gid://shopify/Product/", "")], requestLocations, nextValue, true);
                        const locStock = stockUpdate?.[0]?.locations?.[0];
                        productNode.stock.leadDays = locStock?.availableDays;
                        productNode.stock.available = locStock?.available;
                    }
                }
            }

            const expandMatchArray = (matchArray) => {
                const out = []
                for (const m of (matchArray || [])) {
                    if (m == null) continue
                    try {
                        const parsed = JSON.parse(m)
                        if (Array.isArray(parsed)) out.push(...parsed)
                        else out.push(m)
                    } catch (e) {
                        out.push(m)
                    }
                }
                return out
            }

            const normalizeMatchToken = (value) => {
                return String(value || '').trim().toLowerCase()
            }

            const getProductMatchValues = (productNode) => {
                const raw = productNode?.metafield?.value
                if (!raw) return []
                let parsed = []
                try {
                    parsed = JSON.parse(raw)
                } catch (e) {
                    parsed = [raw]
                }
                const values = Array.isArray(parsed) ? parsed : [parsed]
                return values.map(normalizeMatchToken).filter(Boolean)
            }

            const getCurrentSplitMatches = () => {
                const vehicle = getActiveVehicle()
                if (!vehicle) return null

                const selected = selectedFitment.value
                if (selected?.isSplit) {
                    const frontFromSelected = expandMatchArray(
                        selected.frontMatches || selected.matches || selected?.front?.matches
                    )
                    const rearFromSelected = expandMatchArray(
                        selected.rearMatches || selected.rMatches || selected?.rear?.matches
                    )
                    if (frontFromSelected.length || rearFromSelected.length) {
                        return {
                            frontMatches: frontFromSelected.map(normalizeMatchToken).filter(Boolean),
                            rearMatches: rearFromSelected.map(normalizeMatchToken).filter(Boolean)
                        }
                    }
                }

                const wheelContext = window.location.pathname.includes('heel')
                const fitment = wheelContext
                    ? vehicle?.fitmentInfo?.wheel_fitments?.[0]
                    : vehicle?.fitmentInfo?.tyre_fitments?.[0]
                if (!fitment?.is_split) return null

                const frontRaw = wheelContext ? fitment?.f_wheels?.matches : fitment?.f_tyres?.matches
                const rearRaw = wheelContext ? fitment?.r_wheels?.matches : fitment?.r_tyres?.matches
                return {
                    frontMatches: expandMatchArray(frontRaw).map(normalizeMatchToken).filter(Boolean),
                    rearMatches: expandMatchArray(rearRaw).map(normalizeMatchToken).filter(Boolean)
                }
            }

            const inferNodeAxle = (productNode) => {
                const splitMatches = getCurrentSplitMatches()
                if (!splitMatches?.frontMatches?.length || !splitMatches?.rearMatches?.length) {
                    return productNode?.fits || 'FRONT'
                }
                const values = getProductMatchValues(productNode)
                const nodeMatchesFront = values.some(value => splitMatches.frontMatches.includes(value))
                const nodeMatchesRear = values.some(value => splitMatches.rearMatches.includes(value))
                if (nodeMatchesRear && !nodeMatchesFront) return 'REAR'
                if (nodeMatchesFront && !nodeMatchesRear) return 'FRONT'
                return productNode?.fits || 'FRONT'
            }

            const getSplitNodeByAxle = (productNode, axle) => {
                if (!productNode) return null
                const isRear = axle === 'rear'
                const splitNode = productNode?.splitProduct?.node || null

                if (!splitNode) {
                    const inferredAxle = inferNodeAxle(productNode)
                    if (inferredAxle === 'REAR') {
                        return isRear ? productNode : null
                    }
                    if (inferredAxle === 'FRONT') {
                        return isRear ? null : productNode
                    }
                    return isRear ? null : productNode
                }

                const baseAxle = inferNodeAxle(productNode)
                const splitAxle = inferNodeAxle(splitNode)
                if (baseAxle === 'REAR' && splitAxle === 'FRONT') {
                    return isRear ? productNode : splitNode
                }
                if (baseAxle === 'FRONT' && splitAxle === 'REAR') {
                    return isRear ? splitNode : productNode
                }

                const frontNode = productNode?.fits === 'REAR' ? splitNode : productNode
                const rearNode = productNode?.fits === 'REAR' ? productNode : splitNode
                return isRear ? rearNode : frontNode
            }

            const getSplitStock = (productNode, axle) => {
                return getSplitNodeByAxle(productNode, axle)?.stock || null
            }

            const splitFitmentDisplay = (productNode) => {
                const fitment = getActiveFitment()
                if (!fitment?.isSplit) return null
                if (!productNode?.is_split || !productNode?.splitProduct?.node) return null

                const frontNode = getSplitNodeByAxle(productNode, 'front')
                const rearNode = getSplitNodeByAxle(productNode, 'rear')
                const frontPrice = frontNode?.priceRange?.minVariantPrice?.amount
                const rearPrice = rearNode?.priceRange?.minVariantPrice?.amount

                return {
                    frontSize: fitment.front,
                    rearSize: fitment.rear,
                    frontPrice: promoStore.priceFormat(frontPrice),
                    rearPrice: promoStore.priceFormat(rearPrice),
                    rearAvailable: true
                }
            }

            const fitmentDisplay = (productNode) => {
                const fitment = getActiveFitment()
                if (!fitment) {
                    return {
                        frontSize: '',
                        rearSize: '',
                        frontPrice: '',
                        rearPrice: ''
                    }
                }

                if (fitment.isSplit) {
                    if (productNode?.is_split && productNode?.splitProduct?.node) {
                        return splitFitmentDisplay(productNode)
                    }
                    const basePrice = productNode?.priceRange?.minVariantPrice?.amount
                    const inferredAxle = inferNodeAxle(productNode)
                    if (inferredAxle === 'REAR') {
                        return {
                            frontSize: fitment.front || '',
                            rearSize: fitment.rear || '',
                            frontPrice: 'Not available',
                            rearPrice: promoStore.priceFormat(basePrice),
                            rearAvailable: true
                        }
                    }
                    return {
                        frontSize: fitment.front || '',
                        rearSize: fitment.rear || '',
                        frontPrice: promoStore.priceFormat(basePrice),
                        rearPrice: '',
                        rearAvailable: false
                    }
                }

                const basePrice = productNode?.priceRange?.minVariantPrice?.amount
                return {
                    frontSize: fitment.single || '',
                    rearSize: '',
                    frontPrice: promoStore.priceFormat(basePrice),
                    rearPrice: '',
                    rearAvailable: false
                }
            }

            const addToCart = async (productNode) => {
                if (!productNode) return
                if (getStockStatus(productNode) === 'out') {
                    goToEnquiryPage()
                    return
                }
                const fitmentDisplayResult = splitFitmentDisplay(productNode)
                let basePromo = false;
                if (productNode?.collections?.edges?.findIndex(edge => edge?.node?.type?.value == 'Buy 3 Get 4') > -1) {
                    if (productNode?.collections?.edges?.findIndex(edge => edge?.node?.id === `gid://shopify/Collection/${shopifyConfig.fitmentFeeExemptionCollection}`) === -1) {
                        basePromo = true;
                    }
                }
                if (fitmentDisplayResult) {
                    const frontQty = getSplitQty(productNode, 'front')
                    const rearQty = getSplitQty(productNode, 'rear')
                    const frontNode = getSplitNodeByAxle(productNode, 'front')
                    const rearNode = getSplitNodeByAxle(productNode, 'rear')
                    const frontVariantId = getVariantId(frontNode?.variants?.edges?.[0]?.node?.id)
                    const rearVariantId = getVariantId(rearNode?.variants?.edges?.[0]?.node?.id)
                    const frontPromo = frontNode?.collections?.edges?.findIndex(edge => edge?.node?.type?.value == 'Buy 3 Get 4') > -1 && frontNode?.collections?.edges?.findIndex(edge => edge?.node?.id === `gid://shopify/Collection/${shopifyConfig.fitmentFeeExemptionCollection}`) === -1
                    const rearPromo = rearNode?.collections?.edges?.findIndex(edge => edge?.node?.type?.value == 'Buy 3 Get 4') > -1 && rearNode?.collections?.edges?.findIndex(edge => edge?.node?.id === `gid://shopify/Collection/${shopifyConfig.fitmentFeeExemptionCollection}`) === -1
                    if (frontVariantId && frontQty > 0) await addVariantToCart(frontVariantId, frontQty, frontPromo, productNode)
                    if (rearVariantId && rearQty > 0) await addVariantToCart(rearVariantId, rearQty, rearPromo, productNode)
                    return
                }
                const variantId = getVariantId(productNode?.variants?.edges?.[0]?.node?.id)
                if (variantId) {
                    await addVariantToCart(variantId, 1, basePromo, productNode)
                }
            }

            const addToCartWithQty = async (productNode) => {
                if (!productNode) return
                closeQuantityPicker()
                setCartAdding(productNode)
                const fitmentDisplayResult = splitFitmentDisplay(productNode)
                if (fitmentDisplayResult) {
                    try {
                        await addToCart(productNode)
                        setCartSuccess(productNode)
                    } catch (e) {
                        setCartIdle()
                    }
                    return
                }
                const qty = getPickerQty(productNode)
                if (getFlipSlotStatus(productNode, qty - 1) === 'none') {
                    setCartIdle()
                    return
                }
                const variantId = getVariantId(productNode?.variants?.edges[0]?.node?.id)
                let basePromo = false
                if (productNode?.collections?.edges?.findIndex(edge => edge?.node?.type?.value == 'Buy 3 Get 4') > -1) {
                    if (productNode?.collections?.edges?.findIndex(edge => edge?.node?.id === `gid://shopify/Collection/${shopifyConfig.fitmentFeeExemptionCollection}`) === -1) {
                        basePromo = true
                    }
                }
                try {
                    if (variantId) {
                        await addVariantToCart(variantId, qty, basePromo, productNode)
                        setCartSuccess(productNode)
                    } else {
                        setCartIdle()
                    }
                } catch (e) {
                    setCartIdle()
                }
            }

            const getLabelTags = (productNode) => {
                const tags = productNode?.tags
                if (!Array.isArray(tags)) return []
                return tags
                    .filter((tag) => typeof tag === 'string' && /^label\s*:/i.test(tag))
                    .map((tag) => tag.replace(/^label\s*:\s*/i, '').trim())
                    .filter(Boolean)
            }

            const getProductTitleFromTags = (productNode) => {
                const tags = productNode?.tags
                if (!Array.isArray(tags)) return productNode?.title || ''
                const tag = tags.find((t) => typeof t === 'string' && /^product\s*:/i.test(t))
                if (!tag) return productNode?.title || ''
                return tag.replace(/^product\s*:\s*/i, '').trim()
            }

            const isServiceProduct = (productNode) => {
                const handle = String(productNode?.handle || '').toLowerCase()
                return handle.includes('alignment') || handle.includes('puncture')
            }

            const isStockLoading = (productNode) => {
                if (isServiceProduct(productNode)) return false;
                const stock = productNode?.stock;
                if (!stock || typeof stock !== 'object' || Array.isArray(stock)) return true;
                if (stock.available == null) return true;
                return false
            }

            const getNearestStore = () => {
                try {
                    const storeSelector = window.storeSelector ? window.storeSelector() : null
                    return storeSelector?.nearestStore || null
                } catch (e) { }
                try {
                    const raw = localStorage.getItem('currentNearestStore')
                    return raw ? JSON.parse(raw) : null
                } catch (e) { }
                return null
            }

            const getNearestStoreName = () => {
                const store = getNearestStore()
                const node = store?.node || store
                return node?.name || 'selected store'
            }

            const storeLink = (storeName) => {
                return `${shopifyConfig.storeURL}/pages/${storeName.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')}-t-marts`
            }

            const hasNearestStore = () => {
                return !!getNearestStore()
            }

            const openStoreSelector = () => {
                const button = document.getElementById('my-store-btn')
                if (button) {
                    button.scrollIntoView({ behavior: 'smooth', block: 'center' })
                    button.click()
                }
            }

            const getSplitStockStatus = (productNode, axle) => {
                if (!productNode) return 'loading'
                const targetNode = getSplitNodeByAxle(productNode, axle)
                if (!targetNode) return 'out'
                return getStockStatus(targetNode)
            }

            const getProductUrl = (productNode) => {
                const handle = productNode?.handle || ''
                const base = `/products/${handle}`
                if (!productNode?.is_split || !productNode?.splitProduct?.node) {
                    const inferredAxle = inferNodeAxle(productNode)
                    if (inferredAxle === 'REAR' && handle) {
                        const rearHandle = encodeURIComponent(handle)
                        return `/products/${handle}?r=${rearHandle}`
                    }
                    if (inferredAxle === 'FRONT' && handle && isVehicleSplit()) {
                        const frontHandle = encodeURIComponent(handle)
                        return `/products/${handle}?f=${frontHandle}`
                    }
                    return base
                }

                const frontNode = getSplitNodeByAxle(productNode, 'front')
                const rearNode = getSplitNodeByAxle(productNode, 'rear')
                if (!frontNode?.handle) return base

                const frontHandle = encodeURIComponent(frontNode.handle)
                if (!rearNode?.handle) return `/products/${frontNode.handle}?f=${frontHandle}`

                const rearHandle = encodeURIComponent(rearNode.handle)
                return `/products/${frontNode.handle}?f=${frontHandle}&r=${rearHandle}`
            }

            const getStockStatus = (productNode) => {
                if (isServiceProduct(productNode)) return 'in';
                const stock = productNode?.stock;
                if (!stock || typeof stock !== 'object' || Array.isArray(stock)) return 'loading';
                if (stock.available == null) return 'loading';
                const available = String(stock.available).trim().toUpperCase();
                if (available === 'Y' || available === 'L' || stock.available === true) return 'in';
                if (available === 'N' || stock.available === false) return 'out';
                return 'loading';
            }

            const sendEnquiry = (node, split) => {
                if (split) {
                    localStorage.setItem('storeEnquiry', JSON.stringify(
                        {
                            title: node.title || "",
                            sku: node.tags.filter(tag => tag.includes('sku:'))[0]?.replaceAll('sku:', '') || "",
                            splitTitle: split.title || "",
                            splitSku: split.tags.filter(tag => tag.includes('sku:'))[0]?.replaceAll('sku:', '') || ""
                        }
                    ))
                } else {
                    localStorage.setItem('storeEnquiry', JSON.stringify(
                        {
                            title: node.title || "",
                            sku: node.tags.filter(tag => tag.includes('sku:'))[0]?.replaceAll('sku:', '') || ""
                        }
                    ))
                }

                const existingIndex = (compareRef.selectedProducts || []).findIndex(p =>
                    (p.id || p.node?.id) === node.id
                );

                if (existingIndex == -1) {
                    if (compareRef.selectedProducts.length >= 3) {
                        compareRef.selectedProducts.splice(0, 1);
                    }

                    compareRef.selectedProducts.push({
                        id: node.id,
                        title: node.title,
                        price: node.priceRange.minVariantPrice.amount,
                        featured_image: node.images?.edges[0]?.node?.url || defaultTyreImage,
                        vendor: node.vendor,
                        available: node.availableForSale
                    });
                    compareStore?.persist?.();
                }
                setCartEnquiring(node)
                window.location.href = `${shopifyConfig.storeURL}/pages/${shopifyConfig.contactDefault}`;
            };

            const vehicleName = Vue.computed(() => {
                const activeVehicle = getActiveVehicle()
                return activeVehicle?.make?.display_name && activeVehicle?.model?.display_name
                    ? `${activeVehicle.make.display_name} ${activeVehicle.model.display_name}`
                    : false
            })

            const vehicleMakeName = Vue.computed(() => {
                const activeVehicle = getActiveVehicle()
                return activeVehicle?.make?.display_name
                    ? `${activeVehicle.make.display_name}`
                    : false
            })

            const productsExist = Vue.computed(() => {
                return products?.value?.edges?.length > 0 ? true : false
            })

            const availabilityString = (node) => {
                if (!node?.stock?.leadDays) return 'Available'
                if (node?.stock?.leadDays === 0) {
                    return 'Available Now'
                } else if (node?.stock?.leadDays === 1) {
                    return 'Get it Tomorrow';
                } else if (node?.stock?.leadDays < 7) {
                    let parsedLead = Date.parse(new Date()) + node?.stock?.leadDays * 24 * 60 * 60 * 1000;
                    let day = new Date(parsedLead).toLocaleDateString('en-AU', { weekday: 'long' })
                    if (day == 'Sunday') {
                        return 'Get it by Monday'
                    }
                    return `Get it by ${day}`;
                } else {
                    return `Get it in ${node?.stock?.leadDays} days`;
                }
            }


            const toggleSortUtility = () => {
                showSortUtility.value = !showSortUtility.value;
            }

            return {
                collectionConfig,
                products,
                isWheelCollection,
                filters,
                sortSelector,
                showProduct,
                showFilters,
                isPlpRefreshing,
                checkedInputs,
                toggleCompare,
                closeHover,
                resetHover,
                isCompareModalOpen,
                canCompare,
                openCompareModal,
                closeCompareModal,
                totalCompare,
                clearAll,
                removeFromCompare,
                closeDrawer,
                store,
                compareStore: compareRef,
                isFilterDrawerOpen,
                openFilterDrawer,
                closeFilterDrawer,
                toggleFilterDrawer,
                displayedFilterValues,
                toggleFilterExpansion,
                isFilterExpanded,
                quickFilters,
                toggleQuickFilter,
                isQuickFilterActive,
                splitFitmentDisplay,
                fitmentDisplay,
                isVehicleSplit,
                getSplitQty,
                updateSplitQty,
                addToCart,
                openQuantityPicker,
                closeQuantityPicker,
                isPickerOpen,
                getPickerQty,
                setPickerQty,
                addToCartWithQty,
                getLabelTags,
                getProductTitleFromTags,
                isStockLoading,
                getNearestStoreName,
                storeLink,
                hasNearestStore,
                openStoreSelector,
                getSplitStockStatus,
                getSplitNodeByAxle,
                getSplitStock,
                getStockStatus,
                getCollectionProductType,
                getProductUrl,
                isInCompare,
                promoStore,
                defaultTyreImage,
                vehicleName,
                vehicleMakeName,
                productsExist,
                searchAllProducts,
                clearAllFilters,
                query,
                getFlipSlotAvailable,
                getFlipSlotLeadTime,
                getFlipSlotPrice,
                getFlipSlotStatus,
                getFlipSlotNearbyStoreName,
                sendEnquiry,
                isCartAdding,
                isCartSuccess,
                isCartEnquiring,
                checkedLoad,
                showLoadMoreBtn,
                loadMore,
                isLoadingMore,
                availabilityString,
                vehicleSearch,
                availabilityFilterTools,
                showSortUtility,
                toggleSortUtility
            };
        }
    })
    PLP.use(window.VueAppGlobals.pinia);
    PLP.mount('#PLP');
}

if (window.Vue && window.Pinia) {
    vuePLP()
} else {
    window.addEventListener('vue-ready', vuePLP);
}
